// LoadingAnimation v2.0 - Circular Design with Model Images
import { useState, useEffect } from 'react';
import './LoadingAnimation.css';

const LoadingAnimation = ({ userGender }) => {
  // Randomly select a model image
  const modelNumber = Math.floor(Math.random() * 6) + 1;
  const modelImage = `/images/models/model${modelNumber}.jpg`;

  // Different messages for male and female users
  const maleMessages = [
    'Finding hotties nearby',
    'Loading sexy profiles',
    'Getting you connected',
    'Almost ready',
    'Preparing the fun',
    'Loading your hookups'
  ];

  const femaleMessages = [
    'Loading your dashboard',
    'Preparing your profile',
    'Getting you set up',
    'Almost ready',
    'Setting things up',
    'Loading your workspace'
  ];

  const loadingMessages = userGender === 'FEMALE' ? femaleMessages : maleMessages;

  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [loadingMessages.length]);

  return (
    <div className="loading-container" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'transparent',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <div className="loading-content" style={{
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px'
      }}>
        <div className="circular-loader" style={{
          position: 'relative',
          width: '180px',
          height: '180px',
          background: 'transparent'
        }}>
          <div className="loader-ring"></div>
          <div className="loader-ring-2"></div>
          <img src={modelImage} alt="Loading" className="loader-image" style={{
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            objectFit: 'cover'
          }} />
        </div>
        <div className="loading-text">
          {loadingMessages[messageIndex]}
          <span className="loading-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoadingAnimation;
